import React from 'react';
import styles from './AppPagination.module.scss'
import { Pagination, Select } from "semantic-ui-react";
import { PaginationProps } from "../../common/types/PaginationProps";

interface IAppPaginationProps {
    props: PaginationProps
    isInvertColor?: boolean
    onChangePageSize: (value: any) => void
    onChangePager: (page: any) => void
}

const pagerSelectOptions = [
    {key: 10, value: 10, text: "10 Items"},
    {key: 20, value: 20, text: "20 Items"},
    {key: 50, value: 50, text: "50 Items"},
]

const AppPagination: React.FC<IAppPaginationProps> = ({ props, onChangePageSize, onChangePager, isInvertColor = false}) => {
    return (
        <div className={styles.pagerInner}>
            <Select className={styles.pagerSelect} value={props.pageSize} defaultValue={props.pageSize} options={pagerSelectOptions}
                onChange={(e, {value}) => onChangePageSize(value)} />
            <Pagination className={styles.pagination} floated="right" size="mini" activePage={props.activePage} totalPages={props.totalPages}
                onPageChange={(e, { activePage }) => onChangePager(activePage)} />
        </div>
    );
};

export default AppPagination;
